import React from "react";
import { Helmet } from "react-helmet";

import HowToTraveller from "./HowToComponents/HowToTraveller";
import HowToSender from "./HowToComponents/HowToSender";

export default function About() {
  return (
    <div className="home">
      <Helmet>
        <title>Trippie Air - About Us</title>
        <meta name="description" content="Trippie Air" />
      </Helmet>
      <div className="home-hero bg-gradient">
        <div className="container-middle-content">
          <div className="about-header-text">
            <h1 className="medium-heading">About us</h1>
           <div>
           <p className="medium-para" style={{fontSize: "1.3rem",textAlign:"left"}}> Trippie Air is a technology platform that facilitates delivery services by connecting customers, drivers, and
            businesses. It does not itself provide delivery or transportation services. Trippie is a UAE digital platform
            available as both a mobile app and web application and it has been created to provide an efficient,
            affordable, and tech-enabled delivery experience for businesses and individuals across the UAE.
            Whether you&#39;re a small business, an e-commerce store, or a local entrepreneur, Trippie helps you connect
            with customers by matching your delivery needs to a network of professional delivery fleets. Our platform
            acts as the bridge between businesses and customers thus streamlining delivery. Unlike crowd-sourced or
            on-the-way delivery apps, Trippie focuses on structured, reliable logistics powered by licensed service
            providers operating within cities and across emirates.
            We’re also expanding into future-ready solutions through Trippie Air exploring faster, smarter delivery
            modes to enhance reach and reliability.
             Trippie supports local growth, smarter logistics, and community connections. Join us in reimagining how
            delivery should work as seamless, scalable, and always customer-first.</p>
           </div>
          </div>
        </div>
      </div>
      {/* <div className="container-middle-content">
        <div className="how-to-container">
          <h1 className="small-heading">Steps to being a Driver</h1>
          <HowToTraveller />
        </div>
      </div> */}
      {/* <div className="app-section bg-gradient">
        <div className="container-middle-content how-to-container">
          <h1 className="small-heading">Steps to sending a item</h1>
          <HowToSender />
        </div>
      </div> */}
    </div>
  );
}
